import { useEffect, useState } from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ContainerYampi, ContainerYampiBox, ItemIcons, ItemIntegrtion } from "./styled";

import logoYampi from "../../../../assets/imgs/logo-yampi.png";
import logoDijital from "../../../../assets/imgs/logo01.png";
import logoShopify from "../../../../assets/imgs/shopify-logo.png";

const Code = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const route = useRouteMatch();
  const [isYampiLoading, setIsYampiLoading] = useState(false);

  useEffect(() => {


    //alert("teste code pag")

    if (route.params.type == "sak") {
      alert("teste code pag sak")
      const urlParams = new URLSearchParams(window.location.search);
      dispatch({
        type: "CONTROL_PLATFORM_SUCCESS", payload: {
          typeIntegration: "sak",
          token: urlParams.get("tokenSak"),
          webhook: urlParams.get("webhookSak"),
        }
      })
      history.push('/integracoes');
    }
    else if (route.params.type == "yampi") {
      setIsYampiLoading(true)
      const queryParams = new URLSearchParams(location.search);
      let code = queryParams.get('code');
      let state = queryParams.get('state');
      let merchant = queryParams.get('merchant');
      let code_verifier = queryParams.get('code_verifier');

      dispatch({
        type: "SAGA_INTEGRATE_NEW_INTEGRATION",
        payload: {
          type: route.params.type,
          code: code,
          state: state,
          merchant: merchant,
          code_verifier: code_verifier,
          authYampi: true,
          history: history,
        },
      });


    } else {
      if (route.path == "/integracoes/shopify") {
        const queryParams = new URLSearchParams(location.search);
        const code = queryParams.get("code");
        const shop = queryParams.get("shop");
        const hmac = queryParams.get("hmac");
        const state = queryParams.get("state");
        const savedState = localStorage.getItem("shopify_oauth_state");

        if (!code || !shop || !hmac || !state || !savedState || savedState !== state) {
          toast.error("Falha no retorno do OAuth da Shopify.");
          history.push("/integracoes");
          return;
        }

        const callbackParams = {};
        queryParams.forEach((value, key) => {
          callbackParams[key] = value;
        });
        localStorage.removeItem("shopify_oauth_state");

        dispatch({
          type: "SAGA_INTEGRATE_NEW_INTEGRATION",
          payload: {
            type: "shopify_oauth",
            code,
            shop,
            hmac,
            state,
            callbackParams,
            history,
          },
        });
        return;
      }

      let shop = location.search.substring(location.search.indexOf("shop=") + 5);
      let url = location.search.substring(location.search.indexOf("url=") + 4);
      let clientId = location.search
        .substring(location.search.indexOf("client_id=") + 10)
        .split("&")[0];
      let clientSecret = location.search
        .substring(location.search.indexOf("client_secret=") + 14)
        .split("&")[0];
      let basic = location.search
        .substring(location.search.indexOf("basic=") + 6)
        .split("&")[0];
      let store = location.search
        .substring(location.search.indexOf("store=") + 6)
        .split("&")[0];
      let token = location.search
        .substring(location.search.indexOf("token=") + 6)
        .split("&")[0];
      dispatch({
        type: "CONTROL_PLATFORM_SUCCESS",
        payload: {
          typeIntegration: route.params.type,
          code: location.search.substring(6, location.search.length),
          shop: shop.split("&")[0],
          url: url,
          client_id: clientId,
          client_secret: clientSecret,
          basic: basic,
          store: store,
          token: token,
        },
      });
      history.push("/integracoes");
    }


  }, []);


  const statusSync = useSelector((state) => state.reducerSync);
  const statusIntegration = useSelector((state) => state.reducerIntegration);
  const isShopifyRoute = route.path == "/integracoes/shopify";

  useEffect(() => {

    console.log("statusIntegration", statusIntegration)
    console.log("statusSync", statusSync)

    if (statusIntegration.error || statusSync.error) {
      let mail = statusIntegration.data.data.substring(0, 3) + "*****" + statusIntegration.data.data.substring(statusIntegration.data.data.indexOf("@"));
      //let mail = statusIntegration.data?.data.substring(0, 3) + "*****" + data.data.substring(statusIntegration.data?.data.indexOf("@"));
      statusIntegration.data.length == 0 ?
        toast.error("Erro na integração. 2", { onClose: history.push("/integracoes"), toastId: 0, }) :
        toast.error(statusIntegration.data?.description + ` (${mail})`, { onClose: history.push("/integracoes"), toastId: 0, });
      history.push("/integracoes");
    } else if (statusIntegration.data.length != 0 && statusSync.data.length != 0) {
      toast.success(`Integrado com sucesso.`, { onClose: history.push("/integracoes"), toastId: 0 });
      history.push("/integracoes");
    }
  }, [statusIntegration, statusSync]);



  return (
    isYampiLoading ?
      <ContainerYampi>
        <ContainerYampiBox>

          <ItemIntegrtion>
            <img src={logoDijital} alt="" />
          </ItemIntegrtion>

          <ItemIcons>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="16" viewBox="0 0 32 16" fill="none"><g filter="url(#filter0_d_1866_671)"><path d="M6.5 10L16.2866 9.99977L25.5 9.99969L18.7941 6" stroke="#FFC400" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" shape-rendering="crispEdges"></path></g><defs><filter id="filter0_d_1866_671" x="0.5" y="-0.000366211" width="31.0002" height="16.0004" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1866_671"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1866_671" result="shape"></feBlend></filter></defs></svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="16" viewBox="0 0 32 16" fill="none"><g filter="url(#filter0_d_1866_671)"><path d="M6.5 10L16.2866 9.99977L25.5 9.99969L18.7941 6" stroke="#FFC400" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" shape-rendering="crispEdges"></path></g><defs><filter id="filter0_d_1866_671" x="0.5" y="-0.000366211" width="31.0002" height="16.0004" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1866_671"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1866_671" result="shape"></feBlend></filter></defs></svg>
          </ItemIcons>

          <ItemIntegrtion>
            <img src={logoYampi} alt="" />
          </ItemIntegrtion>

        </ContainerYampiBox>
        <div style={{ fontSize: "14px",}}>Aguarde...</div>
      </ContainerYampi>
      :
      isShopifyRoute ?
        <div
          style={{
            minHeight: "60vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
          }}
        >
          <div
            style={{
              animation: "spin 1s linear infinite",
            }}
          >
            <img src={logoShopify} alt="Shopify" style={{ width: "72px", height: "72px" }} />
          </div>
          <style>
            {`
              @keyframes spin {
                from { transform: rotate(0deg); }
                to { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
        :
        <>
          {"Carregando..."}
        </>

  )
}

export default Code;
